import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpInputDescription } from "../../gvc/testNewForm/CpInputDescription";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";

export const General: React.FC = () => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            Identity
            <CpErrorWarningArrayIcon names={["name", "description", "gvc"]} />
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`name`}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={`name`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`name`} />
            </CpFormItem>
            <CpInputDescription namePath="name" descriptionPath="description" />
            <CpFormItem>
              <CpLabel name={`gvc`}>GVC</CpLabel>
              <CpKindSelect optionValue="name" kind={`gvc`} name={`gvc`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`gvc`} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
